import { ref, onMounted, onUnmounted } from 'vue';

const MOBILE_SHORT_SIDE = 500;
const MOBILE_LONG_SIDE = 1000;

function checkMobile() {
  const short = Math.min(window.innerWidth, window.innerHeight);
  const long = Math.max(window.innerWidth, window.innerHeight);
  return short < MOBILE_SHORT_SIDE && long < MOBILE_LONG_SIDE;
}

export default function useIsMobile() {
  const isMobile = ref(checkMobile());

  const update = () => {
    isMobile.value = checkMobile();
  };

  onMounted(() => window.addEventListener('resize', update));
  onUnmounted(() => window.removeEventListener('resize', update));

  return isMobile;
}
